/**
 * Errors for failed backend calls. A 429 (the app-wide RATE_LIMITED limit or the
 * DAILY_SUBMISSION_LIMIT paper cap) carries the backend's user-facing message,
 * so callers can show it as-is; anything else keeps the caller's own message.
 * Every error also has `status`, and `code`/`body` when the response was JSON.
 */

function build(status, body, fallbackMessage) {
    const message = status === 429
        ? body?.message || "Too many requests. Please wait a moment and try again."
        : fallbackMessage;
    return Object.assign(new Error(message), { status, code: body?.error, body });
}

/** For fetch() responses. */
export async function responseError(response) {
    let body = null;
    try {
        body = await response.json();
    } catch { /* not JSON */ }
    return build(response.status, body, `Request failed: ${response.status}`);
}

/** For a completed XMLHttpRequest. */
export function xhrError(xhr, fallbackMessage) {
    let body = null;
    try {
        body = JSON.parse(xhr.responseText);
    } catch { /* not JSON */ }
    return build(xhr.status, body, fallbackMessage);
}

export function isRateLimited(err) {
    return err?.status === 429;
}

/** The message to show for a caught error: the backend's on a 429, else the fallback. */
export function errorMessage(err, fallbackMessage) {
    return isRateLimited(err) && err.message ? err.message : fallbackMessage;
}
